import EditIcon from "@mui/icons-material/Edit";
import { Leads } from "../../../api/Endpoints/Leads";
import { Projects } from "../../../api/Endpoints/project";
import { useEffect, useState, forwardRef } from "react";
import {
  Badge,
  Box,
  Button,
  Card,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Slide,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { LoadingButton } from '@mui/lab';
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DateInput from "../../../components/Form/DateInput";
import { useForm } from "react-hook-form";
import StatusSelector from "../../../components/Form/Status";
import DeleteIcon from "@mui/icons-material/Delete";
import Create from "./create";
import PageHeader from "../../../components/PageHeader/PageHeader";
import View from "./View";
import AssignTo from "../../../components/Form/AssignTo";
import useAssignees from "../../../components/CommonFunctions/Usres";
import Delete from "../../../components/Popup/Delete";
import CloseLeadPopup from "../../../components/Popup/ClosedLead";
import { Waveform } from "@uiball/loaders";
import ImportLead from "./ImportLead/Index";
import { GlobalRefreshContext } from "../../../contexts/GlobalRefresh/GlobalRefresh";
import { Fragment } from "react";
import StatusLIstFunction from "../../../components/CommonFunctions/statusLIst";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { FileDownload } from "../../../api/Endpoints/fileDowenold";
import ArchiveIcon from "@mui/icons-material/Archive";
import BlockIcon from '@mui/icons-material/Block';
import { toast } from "react-toastify";
import FilterListIcon from "@mui/icons-material/FilterList";
import LeadFilter from "../../../components/Popup/LeadFilter";
import FilterBadges from "../../../components/FilterBadge/FilterBadges";
import SearchField from "../../../components/TableElements/SearchField";
import TextInput from "../../../components/Form/TextInput";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import QuickEdit from "../../../components/Popup/QuickEditTab";
import WarningIcon from "@mui/icons-material/Warning";
import DataList from "../../../components/Popup/RepeatedLead";
import WhereToVoteIcon from "@mui/icons-material/WhereToVote";
import ProjectUserPriority from "../../../components/Popup/ProjectUserPriority";
import TuneIcon from "@mui/icons-material/Tune";
import LabelsList from "../../../components/CommonFunctions/LabelsList";
import LabelSelector from "../../../components/Form/LabelSelector";
import DescriptionIcon from "@mui/icons-material/Description";
import NotesDownloadPopup from "../../../components/Popup/NotesDownloadPopup";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function LeadsTable() {
  const [isHovered, setIsHovered] = useState(false);
  const [rowId, setRowID] = useState();
  const [quickEditOpen, setQuickEditOpen] = useState(false);
  const columns = [
    {
      field: "name",
      headerName: "Customer Name",
      flex: 1.8,
      minWidth: 180,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              whiteSpace: "break-spaces",
            }}
          >
            <div
              onMouseEnter={() => {
                setIsHovered(true);
                // Only set rowId if QuickEdit is not open
                if (!quickEditOpen) {
                  setRowID(params.row.id);
                }
              }}
              onMouseLeave={() => {
                setIsHovered(false);
                // Only clear rowId if QuickEdit is not open
                if (!quickEditOpen) {
                  setRowID("");
                }
              }}
            >
              <span
                style={{
                  cursor: "pointer",
                }}
                onClick={() => viewTabs(params)}
              >
                {params.row.name}
              </span>
              {isHovered && rowId === params.row.id && (
                <IconButton
                  size="small"
                  onClick={() => handleQuickEdit(params.row)}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              )}
            </div>
            {params.row.duplicate_flag === true && (
              <IconButton onClick={() => hanldeRepeatLeadClick(params.row)}>
                <WarningIcon
                  sx={{
                    fontSize: 18,
                    color: "#FAAB53",
                  }}
                />
              </IconButton>
            )}

            {params.row.site_visit_count > 0 && (
              <Tooltip
                title={`Site Visit Count: ${params.row.site_visit_count}`}
                arrow
              >
                <IconButton sx={{ cursor: "default" }}>
                  <WhereToVoteIcon color="error" />
                </IconButton>
              </Tooltip>
            )}
          </div>
        );
      },
    },

    {
      field: "assigned_to_details",
      headerName: "Assign To",
      width: 120,
      renderCell: (params) => (
        <>
          <Button size="small" style={{ color: "#6f6f6f" }}>
            <AssignTo
              id={params.id}
              isAssigned={params.row.assigned_to_details}
              name={`assigned_to_details`}
              assignees={assignees}
              isLoading={isLoading}
              setValue={setValue}
              // func={() => { fetchLeadsForTableUpdate() }}
              watch={watch}
            />
          </Button>
        </>
      ),
    },

    {
      field: "created_at",
      headerName: "Date",
      width: 120,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <DateInput
            id={params.id}
            name={`created_at-${params.id}`}
            value={params.row.created_at}
            control={control}
            setValue={setValue}
            compactTable={true}
            readOnly={true}
          />
        );
      },
    },
    {
      field: "source_name",
      headerName: "Source",
      width: 80,
      renderCell: (params) => {
        return (
          <Typography style={{ color: "#6f6f6f" }}>
            {params.row?.source}
          </Typography>
        );
      },
    },
    {
      field: "project_name",
      headerName: "Project Name",
      width: 450,
      cellClassName: "wrap-text-cell",
      renderCell: (params) => {
        return (
          <Typography
            sx={{ color: "#6f6f6f", whiteSpace: "normal !important" }}
          >
            {params.row?.project?.name}
          </Typography>
        );
      },
    },

    {
      field: "follow_up_date",
      headerName: "Follow Up",
      width: 130,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const { id } = params;
        return (
          <DateInput
            id={id} // Pass the unique identifier for this specific date field
            name={`follow_up_date-${id}`}
            // Provide a unique name for each date field
            control={control}
            setValue={setValue}
            // watch={watch}
            value={params.row?.follow_up_date}
            compactTable={true}
            // Update the watch function call here
            func={() => {
              fetchLeadsForTableUpdate();
            }}
          />
        );
      },
    },
    {
      field: "lead_labels",
      headerName: "Labels",
      width: 140,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const labels = params.row.label || params.row.lead_labels || [];
        return (
          <Box sx={{ width: "120px" }}>
            <LabelSelector
              id={params.row?.id}
              currentLabel={labels}
              labelOptions={labelsMaster}
              func={fetchLeadsForTableUpdate}
            />
          </Box>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 130,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const labels = params.row.label || params.row.lead_labels || [];
        const hasLabel = Array.isArray(labels) && labels.length > 0;
        return (
          <Box
            sx={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <StatusSelector
              statusList={statusList}
              options={params.row?.crm_status_details}
              id={params.id}
              func={fetchLeads}
              requireNotes={true}
              requireLabel={true}
              hasLabel={hasLabel}
            />
          </Box>
        );
      },
    },

    {
      field: "actions",
      headerName: "",
      width: 70,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => <MoreOptionsDropdown params={params} />,
    },
  ];

  const {
    watch,
    formState: { errors },
    control,
    Controller,
    setValue,
    reset,
  } = useForm({});

  const [loading, setLoading] = useState(false);
  const [leads, setLeads] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const [editId, setEditId] = useState(undefined);
  const [ViewID, setViewID] = useState(0);
  const [DeleteID, setDeleteID] = useState(0);
  const [isMounted, setIsMounted] = useState(false);
  const [showClosePopup, setShowClosePopup] = useState(false);
  const [CloseID, setCloseID] = useState(0);
  const { GlobalRefresh } = GlobalRefreshContext();
  const [selectedRow, setSelectedRow] = useState([]);
  const [showFilterPopup, setShowFilterPopup] = useState(false);
  const leadTypeData = JSON.parse(sessionStorage.getItem("Lead_type"));
  const projectData = JSON.parse(sessionStorage.getItem("project"));
  const [TableUpdate, setTableUpdate] = useState(false);
  const [serachEntry, setSearchEntry] = useState("");
  const [repatedLeadOpen, setRepeatedLeadOpen] = useState(false);
  const [ID, setID] = useState(0);
  const [projectUserPriorityOpen, setProjectUserPriorityOpen] = useState(false);
  const [showNotesPopup, setShowNotesPopup] = useState(false);
  const [banLeadId, setBanLeadId] = useState(0);
  const [banning, setBanning] = useState(false);
  const [banDialogOpen, setBanDialogOpen] = useState(false);
  const [projectsList, setProjectsList] = useState([]);
  const [projectsLoading, setProjectsLoading] = useState(false);
  const [selectedProjectIds, setSelectedProjectIds] = useState([]);

  const [filterData, setFilterData] = useState({
    from: "",
    to: "",
    assing_to_users: "",
    lead_source: "",
    campaign_name: "",
    project_id: "",
    crm_status: "",
  });

  const location = useLocation();

  const navigate = useNavigate();
  const getPageNumber = () => {
    const queryParams = new URLSearchParams(location.search);
    return queryParams.get("page");
  };

  const pageNumber = getPageNumber();
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: pageNumber || 0,
  });

  async function fetchLeads() {
    try {
      if (!TableUpdate) {
        setLoading(true);
      }
      const response = await Leads.get({
        page: parseInt(paginationModel?.page) + 1,
        crm_lead_type_id: leadTypeData?.ID,
        project_id: filterData?.project_id || projectData.ID,
        from_date: filterData.from,
        to_date: filterData.to,
        assigned_users: filterData?.assing_to_users,
        crm_status: filterData?.crm_status,
        lead_source: filterData.lead_source,
        filter: serachEntry || watch("searchbynameorphoneoremail"),
        campaign_name: filterData?.campaign_name,
      });
      //console.log("Leads Data:", response.data.leads);
      setLeads(response.data.leads);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    } finally {
      if (TableUpdate) {
        setTableUpdate(false);
      }
    }
  }

  const handleFilter = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const page = queryParams.get("page");

    if (page) {
      queryParams.delete("page");

      setPaginationModel({
        pageSize: 15,
        page: 0,
      });
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${queryParams}`,
      );
    }
    setFilterData({
      from: watch("from")
        ? moment(watch("from")).format("DD-MM-YYYY")
        : undefined,
      to: watch("to") ? moment(watch("to")).format("DD-MM-YYYY") : undefined,
      assing_to_users:
        watch("assing_to_users") &&
        watch("assing_to_users").map((assignUser) => assignUser.id),
      lead_source:
        watch("lead_source") &&
        watch("lead_source").map((leadSource) => leadSource.name),
      searchbynameorphoneoremail: watch("searchbynameorphoneoremail") || null,
      project_id:
        watch("project_id") &&
        watch("project_id").map((project) => project.id),
      crm_status:
        watch("crm_status") &&
        watch("crm_status").map((status) => status.slug),
    });

    setShowFilterPopup(false);
  };

  async function fetchLeadsForTableUpdate() {
    try {
      const response = await Leads.get({
        page: parseInt(paginationModel?.page) + 1,
        crm_lead_type_id: leadTypeData?.ID,
        project_id: filterData?.project_id || projectData.ID,
        from_date: filterData?.from,
        to_date: filterData?.to,
        assigned_users: filterData?.assing_to_users,
        crm_status: filterData?.crm_status,
        lead_source: filterData?.lead_source,
        filter: serachEntry || watch("searchbynameorphoneoremail"),
        campaign_name: filterData?.campaign_name,
      });
      setLeads(response.data.leads);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (banLeadId > 0) {
      setBanDialogOpen(true);
      setSelectedProjectIds([]);
      fetchProjectsForBan();
    } else {
      setBanDialogOpen(false);
    }
  }, [banLeadId]);

  const handleBanClose = () => {
    setBanDialogOpen(false);
    setSelectedProjectIds([]);
    setTimeout(() => setBanLeadId(0), 100);
  };

  const handleProjectToggle = (projectId) => {
    setSelectedProjectIds((prev) =>
      prev.includes(projectId)
        ? prev.filter((id) => id !== projectId)
        : [...prev, projectId]
    );
  };

  async function fetchProjectsForBan() {
    setProjectsLoading(true);
    try {
      const response = await Leads.getProjects();
      setProjectsList(response.data.projects || []);
    } catch (error) {
      console.log(error);
    } finally {
      setProjectsLoading(false);
    }
  }

  async function handleBanConfirm() {
    setBanning(true);
    try {
      const payload = { id: Number(banLeadId) };
      if (selectedProjectIds.length > 0) {
        payload.project_ids = selectedProjectIds;
      }
      const response = await Leads.banLead(payload);
      if (response.data.status) {
        toast.success("Lead has been banned successfully.", { autoClose: 1000 });
        handleBanClose();
        fetchLeadsForTableUpdate();
      } else {
        toast.error("Failed to ban lead. Please try again.", { autoClose: 2000 });
      }
    } catch (error) {
      console.log(error);
      toast.error("An error occurred. Please try again later.", { autoClose: 2000 });
    } finally {
      setBanning(false);
    }
  }

  const { assignees, isLoading, fetchAssignees } = useAssignees();
  const { statusList, fetchStatusList } = StatusLIstFunction();
  const { labels: labelsMaster, fetchLabels } = LabelsList();

  function handlePageChange(page) {
    setPaginationModel(page);
    const queryParams = new URLSearchParams(location.search);
    if (page && page.page > 0) {
      queryParams.set("page", page.page);
    } else {
      queryParams.delete("page");
    }
    navigate(`${location.pathname}?${queryParams.toString()}`, {
      replace: true,
    });
    setRefresh(Math.random);
  }

  function handleQuickEdit(row) {
    setRowID(row?.id);
    setQuickEditOpen(true);
  }

  const MoreOptionsDropdown = ({ params }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleEdit = (id) => {
      setEditId(parseInt(id));
    };

    const handleDelete = (id) => {
      setDeleteID(id);
      handleClose();
    };
    const handleCloseLead = (id) => {
      setCloseID(id);
      setShowClosePopup(true);
    };
    const handleBanClick = (id) => {
      setBanLeadId(id);
      setBanDialogOpen(true);
      handleClose();
    };

    return (
      <>
        <IconButton size="small" onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem class="edit-nav-cntr" onClick={() => handleEdit(params.id)}>
            <EditIcon sx={{ fontSize: 14, mr: 1 }} />
            Edit
          </MenuItem>
          <MenuItem
            class="edit-nav-cntr delete-sec"
            onClick={() => handleDelete(params.id)}
          >
            <DeleteIcon sx={{ fontSize: 14, mr: 1 }} />
            Delete
          </MenuItem>
          <MenuItem
            class="edit-nav-cntr"
            onClick={() => handleCloseLead(params.id)}
          >
            <ArchiveIcon sx={{ fontSize: 14, mr: 1 }} />
            Archive
          </MenuItem>
          <MenuItem
            class="edit-nav-cntr"
            onClick={() => handleBanClick(params.id)}
          >
            <BlockIcon sx={{ fontSize: 14, mr: 1 }} />
            Ban Lead
          </MenuItem>
        </Menu>
      </>
    );
  };

  useEffect(() => {
    fetchLeads();
  }, [serachEntry, refresh, GlobalRefresh, filterData]);

  useEffect(() => {
    fetchStatusList();
    fetchLabels();
  }, []);

  const handleCreate = () => {
    setEditId(0);
  };
  const handleUpdate = () => {
    setRefresh(Math.random);
  };
  const showFilterPopupFunc = () => {
    setShowFilterPopup(true);
  };

  const closeFilterBadge = (filterName) => {
    setFilterData((prevFilterData) => ({
      ...prevFilterData,
      [filterName]: null,
    }));
    setValue(filterName, null);
    setRefresh(Math.random);
  };

  function viewTabs(params) {
    setViewID(params.id);
  }

  const handleRowSelection = (newSelection) => {
    setSelectedRow(newSelection);
  };

  const handleRowSelectionDelete = () => {
    if (selectedRow.length > 0) {
      setDeleteID(selectedRow);
    } else {
      toast.warning("Please select a lead to delete", { autoClose: 3000 });
    }
  };

  const fileDownloadHandler = async () => {
    const response = await FileDownload.get({
      from_date: watch("from")
        ? moment(watch("from")).format("DD-MM-YYYY")
        : undefined,
      to_date: watch("to")
        ? moment(watch("to")).format("DD-MM-YYYY")
        : undefined,
      project_id: projectData?.ID,
      assigned_users:
        watch("assing_to_users") &&
        watch("assing_to_users").map((assignUser) => assignUser.id),
      lead_source:
        watch("lead_source") &&
        watch("lead_source").map((leadSource) => leadSource.name),
    });
    const url = response?.data.export;

    if (url) {
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.setAttribute("download", " ");
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    } else {
      console.error("Invalid URL for file download");
    }
  };
  const clearSerachInput = () => {
    setSearchEntry("");
    setPaginationModel({
      pageSize: 15,
      page: 0,
    });
  };
  const handleSearchEntry = (event) => {
    setPaginationModel({
      pageSize: 15,
      page: 0,
    });
    // closeFilterBadge('searchbynameorphoneoremail', null)

    setSearchEntry(event.target.value);
    setTableUpdate(true);
  };

  function hanldeRepeatLeadClick(id) {
    setID(id?.id);
    setRepeatedLeadOpen(true);
  }

  return (
    <>
      <QuickEdit
        open={quickEditOpen}
        setOpen={(open) => {
          // When closing the QuickEdit, also reset the rowId
          if (!open) {
            setRowID("");
          }
          setQuickEditOpen(open);
        }}
        id={rowId}
        refreshLeadsTable={fetchLeads}
      />
      <DataList
        open={repatedLeadOpen}
        setOpen={setRepeatedLeadOpen}
        ID={ID}
        setID={setID}
      />
      <ProjectUserPriority
        open={projectUserPriorityOpen}
        setOpen={setProjectUserPriorityOpen}
      />
      <div class="page-cntr">
        <div class="lead-table lead-page-cntr" style={{ width: 'fit-content' }}>
          {/* Popup */}
          {}{" "}
          <Delete
            DeleteID={DeleteID}
            setDeleteID={setDeleteID}
            Callfunc={fetchLeadsForTableUpdate}
            url={
              DeleteID.length > 0
                ? "/lead/action/bulk-delete"
                : "/lead/action/delete"
            }
            title={DeleteID.length > 0 ? "Leads" : "this Lead"}
          />
          {showClosePopup && (
            <CloseLeadPopup
              id={CloseID}
              setShowClosePopup={setShowClosePopup}
              func={fetchLeads}
            />
          )}
          <Dialog
            open={banDialogOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleBanClose}
            aria-describedby="ban-lead-dialog-description"
          >
            <DialogTitle>Ban Lead</DialogTitle>
            <DialogContent>
              <DialogContentText sx={{ mb: 2 }}>
                Select projects to ban this lead from, or leave empty to ban from all projects.
              </DialogContentText>
              {projectsLoading ? (
                <Typography variant="body2" color="text.secondary">
                  Loading projects...
                </Typography>
              ) : (
                <Box sx={{ maxHeight: 300, overflowY: "auto" }}>
                  {projectsList.map((project) => (
                    <FormControlLabel
                      key={project.id}
                      control={
                        <Checkbox
                          checked={selectedProjectIds.includes(project.id)}
                          onChange={() => handleProjectToggle(project.id)}
                        />
                      }
                      label={project.name}
                    />
                  ))}
                </Box>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={handleBanClose} variant="outlined" color="inherit">
                Cancel
              </Button>
              <LoadingButton
                onClick={handleBanConfirm}
                loading={banning}
                variant="outlined"
                color="error"
              >
                {selectedProjectIds.length > 0 ? "Submit" : "Ban from All Projects"}
              </LoadingButton>
            </DialogActions>
          </Dialog>
          {showNotesPopup && (
            <NotesDownloadPopup
              open={showNotesPopup}
              setOpen={setShowNotesPopup}
              watch={watch}
              control={control}
              reset={reset}
              setValue={setValue}
            />
          )}
          {showFilterPopup && (
            <LeadFilter
              open={showFilterPopup}
              setOpen={setShowFilterPopup}
              watch={watch}
              control={control}
              reset={reset}
              handleFilter={handleFilter}
              setFilterData={setFilterData}
              setValue={setValue}
            />
          )}
          <div class="title-sec">
            <Card
              sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}
            >
              <PageHeader title={"Leads"} total={!loading && leads.total} />

              <SearchField
                clearSerachInput={clearSerachInput}
                name={"search"}
                placeholder="Name,Email or Phone"
                serachEntry={serachEntry}
                handleSearchEntry={handleSearchEntry}
              />
              <div className="grid grid-cols-5 gap-[15px] header-icon-block">
                {localStorage.getItem('def_') === 'Manager' && (
                  <Tooltip title="Export leads with notes" arrow>
                    <IconButton
                      className="export-icon"
                      sx={{ mr: 2 }}
                      edge="end"
                      onClick={() => setShowNotesPopup(true)}
                    >
                      <DescriptionIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                )}
                <Tooltip title="Filters" arrow>
                  <IconButton
                    className="filter-btn-pop"
                    sx={{ mr: 2 }}
                    edge="end"
                    onClick={showFilterPopupFunc}
                  >
                    <FilterListIcon />
                  </IconButton>
                </Tooltip>
                <ImportLead handleUpdate={handleUpdate} />

                <IconButton
                  className="dlt-icon"
                  sx={{ mr: 2 }}
                  edge="end"
                  onClick={handleRowSelectionDelete}
                >
                  <DeleteIcon className="delete-icon" color="red" />
                </IconButton>

                <Tooltip title="download" arrow>
                  <IconButton
                    className="export-icon"
                    sx={{ mr: 2 }}
                    edge="end"
                    onClick={fileDownloadHandler}
                  >
                    <FileDownloadIcon className="delete-icon" color="red" />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Project User Priority" arrow>
                  <IconButton
                    className="export-icon"
                    sx={{ mr: 0 }}
                    edge="end"
                    onClick={() => setProjectUserPriorityOpen(true)}
                  >
                    <TuneIcon />
                  </IconButton>
                </Tooltip>
              </div>

              <Create
                onNew={handleCreate}
                onUpdate={handleUpdate}
                editId={editId}
                setEditId={setEditId}
              />
            </Card>
            {/* {
                        leads?.data?.length > 0 && !loading ?

                        

                            : null
                    } */}

            <View
              viewID={ViewID}
              setViewID={setViewID}
              watch={watch}
              control={control}
              page={paginationModel.page}
              setFormValue={setValue}
              assignees={assignees}
              setValue={setValue}
              statusList={statusList}
              func={fetchLeadsForTableUpdate}
              searchIsEnabled={serachEntry && true}
            />
          </div>
          <Grid container sx={{ display: "flex", justifyContent: "end" }}>
            {filterData?.from && (
              <FilterBadges
                label={"From"}
                value={filterData.from}
                handleClose={() => closeFilterBadge("from")}
              />
            )}

            {filterData?.to && (
              <FilterBadges
                label={"To"}
                value={filterData.to}
                handleClose={() => closeFilterBadge("to")}
              />
            )}
            {filterData?.assing_to_users?.length > 0 && (
              <FilterBadges
                label={"Assigned User"}
                value={`${filterData?.assing_to_users.length} option selected`}
                handleClose={() => closeFilterBadge("assing_to_users")}
              />
            )}
            {filterData?.lead_source?.length > 0 && (
              <FilterBadges
                label={"Lead Source"}
                value={`${filterData?.lead_source.length} option selected`}
                handleClose={() => closeFilterBadge("lead_source")}
              />
            )}
            {filterData?.project_id?.length > 0 && (
              <FilterBadges
                label={"Project"}
                value={`${filterData?.project_id.length} option selected`}
                handleClose={() => closeFilterBadge("project_id")}
              />
            )}
            {filterData?.crm_status?.length > 0 && (
              <FilterBadges
                label={"Status"}
                value={`${filterData?.crm_status.length} option selected`}
                handleClose={() => closeFilterBadge("crm_status")}
              />
            )}
            {filterData?.searchbynameorphoneoremail && (
              <FilterBadges
                label={"Search by"}
                value={filterData.searchbynameorphoneoremail}
                handleClose={() =>
                  closeFilterBadge("searchbynameorphoneoremail")
                }
              />
            )}
          </Grid>
          {!TableUpdate && loading ? (
            <Box
              sx={{
                width: "100%",
                marginTop: 10,
                height: 80,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Waveform size={40} lineWeight={3.5} speed={1} color="blue" />
            </Box>
          ) : (
            <>
              {leads.data?.length > 0 ? (
                <Fragment>
                  <Card
                    sx={{
                      m: 0,
                      overflowX: "auto",
                    }}
                    variant="outlined"
                    class="lead-table leads-list-grid"
                  >
                    {typeof leads.data === "object" && (
                      <DataGrid
                        sx={{
                          width: "100%",
                          "& .MuiDataGrid-columnHeader[data-field='follow_up_date']": {
                            px: 0,
                            mr: 0,
                          },
                          "& .MuiDataGrid-cell[data-field='follow_up_date']": {
                            px: 0,
                            mr: 0,
                          },
                        }}
                        paginationMode="server"
                        rows={leads?.data}
                        paginationModel={paginationModel}
                        columns={columns}
                        rowCount={leads?.total}
                        rowHeight={70}
                        autoHeight={true}
                        scrollbarSize={10}
                        density="compact"
                        checkboxSelection
                        onPaginationModelChange={handlePageChange}
                        onRowSelectionModelChange={handleRowSelection}
                        disableColumnMenu
                        disableRowSelectionOnClick
                        disableExtendRowFullWidth
                      />
                    )}
                  </Card>
                </Fragment>
              ) : (
                <Box
                  sx={{
                    width: "100%",
                    marginTop: 15,
                    height: 40,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography>Leads not found</Typography>
                </Box>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}
